import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import PrintersApp from './PrintersApp'
import { LoadingButton } from '@mui/lab'
import DynamicItemViewPage from '../admin/DynamicItemViewPage'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import api from '../../services/api'
import PrinterJobsList from './PrinterJobsList'

interface IProps {
    customId?: number,
}

export default function ViewSinglePrinterPage(props: IProps) {

    const {
        customId
    } = props

    const dispatch = useDispatch()

    const params = useParams()
    const printerId = customId ? customId : params.id ? Number(params.id) : 0

    const [loading, setLoadig] = useState<boolean>(false)

    const printersApp = new PrintersApp()

    const downloadPrintingAgent = async() => {
        const res = await api.get(
            `printing/printers/${printerId}/download-agent`,
            { responseType: "blob" }
        )

        const blob = new Blob([res.data], { type: "application/zip" })
        const url = window.URL.createObjectURL(blob)

        const a = document.createElement("a")
        a.href = url
        a.download = `print_agent_${printerId}.zip`
        document.body.appendChild(a)
        a.click()
        a.remove()

        window.URL.revokeObjectURL(url)
    }

    const additionalContent = () => {
        return(
            <div className="action-buttons-of-section-box-admin-panel">
                <div className="content-of-action-buttons-of-section-box-admin-panel">

                    <LoadingButton loading={loading} onClick={() => downloadPrintingAgent()} className="general-button admin-style light-button" color="success" variant="contained">Download Print Agent</LoadingButton>

                </div>
            </div>
        )
    }

    return(
        <div>
            <DynamicItemViewPage additionalContent={additionalContent} customPage="printers" customId={customId} />

            <SectionBoxContainer showTitle title="Printing Jobs">
                <PrinterJobsList printerId={printerId} />
            </SectionBoxContainer>
        </div>
    )

}